import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";

// Import required modules
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const Wishlist = () => {
  const history = useHistory();
  const [wishlist, setWishlist] = useState([]);
  const [cart_data, setCartDetail] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [products, setProducts] = useState([]);
   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Load from localStorage when component mounts
  useEffect(() => {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    setWishlist(wishlist);
    // setCart(storedCart);
  }, []);

  // ✅ Update quantity
  //   const updateQuantity = (id, newQty) => {
  //    let updatedCart = cart.map((item) =>
  //       item.id === id ? { ...item, quantity: Math.max(1, newQty) } : item
  //     );
  //     setCart(updatedCart);
  //       localStorage.setItem("cart", JSON.stringify(updatedCart));
  //   };

  // ✅ Remove item from cart
  //   const removeFromCart = (id) => {
  //     let updatedCart = cart.filter((item) => item.id !== id);
  //     setCart(updatedCart);
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //   };

  // ✅ Clear entire cart
  //   const clearCart = () => {
  //     setCart([]);
  //      localStorage.clear();
  //   };

  // ✅ Subtotal calculation
  const subtotal = wishlist.reduce((sum, item) => sum + 100, 0);

  const fetchProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/get`) // 👈 your API endpoint
      .then((response) => {
        if (response.data.product.length > 0) {
          setProducts(response.data.product); // Store product data
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    fetchProducts();
    //   fetchProductImages();
  }, []);

  //     const fetchProductImages = () => {
  //     axios
  //       .post("https://sachiproduct-backend.theaditech.in/api/product_image/get", {
  //         product_id: product_type_id,
  //       }) // 👈 your API endpoint
  //       .then((response) => {
  //         if (response.data.product.length > 0) {
  //           setProductImages(response.data.product); // Store product data
  //         } else {
  //           setProductImages([]);
  //         }
  //       })
  //       .catch((err) => {
  //         // setError(err.message);
  //         // setLoading(false);
  //       });
  //   };

  const handleAddtoCart = (e) => {
    //    console.log({cart_detail});
  };

  const removeFromWishlist = (id) => {
    const updated = wishlist.filter((item) => item.id !== id);
    setWishlist(updated);
    localStorage.setItem("wishlist", JSON.stringify(updated));
  };
  const addToCartFromWishlist = (product) => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // check if already in cart
    const existingIndex = cart.findIndex((item) => item.id === product.id);
    if (existingIndex >= 0) {
      cart[existingIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    // update both localStorage
    localStorage.setItem("cart", JSON.stringify(cart));

    // remove from wishlist
    removeFromWishlist(product.id);
    history.push("/cart");
  };

  
  return (
    <main className="main-content site-wrapper-reveal">
      {/* <!--== Start Page Title Area ==--> */}
      <section
        className="page-title-area"
        data-bg-img="assets/img/photos/bg-page-title.webp"
        style={{ backgroundColor: "gray" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-content text-center">
                <h2 className="title text-white">YOUR WISHLIST</h2>
                <div className="bread-crumbs">
                  <Link to="/">
                    Home<span className="breadcrumb-sep">/</span>
                  </Link>
                  <span className="active">Your Wishlist</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Page Title Area ==--> */}

      {/* <!--== Start Cart Area Wrapper ==--> */}
      <section className="cart-page-area">
        <div className="container pt-100 pb-100">
          <div className="row">
            <div className="col-12">
              <div className="cart-table table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th className="pro-thumbnail">Image</th>
                      <th className="pro-title">Product</th>
                      <th className="pro-price">Price</th>
                      <th className="pro-remove">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {wishlist.map((element) => (
                      <tr key={element.id}>
                        <td className="pro-thumbnail">
                          <img
                            src={`${BASE_URL}/${element.image}`}
                            alt={element.name}
                            style={{ width: "80px" }}
                          />
                        </td>
                        <td className="pro-title">
                          <h4>{element.name}</h4>
                        </td>
                        <td className="pro-price">
                          <span>$100</span>
                        </td>
                        <td className="pro-remove">
                          <button
                            type="button"
                            onClick={() => addToCartFromWishlist(element)}
                          >
                            Add to Cart
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-12">
              <div className="cart-buttons">
                <Link className="btn-shopping" to="/product">
                  Continue Shopping
                </Link>
                {/* <button className="btn-shopping" onClick={clearCart}>
                Clear Cart
              </button> */}
              </div>
            </div>

            <div className="col-12">
              <div className="cart-payment">
                <div className="cart-subtotal">
                  <h3 className="title">Cart Totals</h3>
                  <table>
                    <tbody>
                      <tr className="cart-subtotal">
                        <th>Subtotal</th>
                        <td>
                          <span className="amount">${subtotal.toFixed(2)}</span>
                        </td>
                      </tr>
                      <tr className="order-total">
                        <th>Total</th>
                        <td>
                          <span className="price">${subtotal.toFixed(2)}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Link className="btn-theme" to="/checkout">
                    Proceed to Checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Cart Area Wrapper ==--> */}
    </main>
  );
};
export default Wishlist;
